import styled from "styled-components";

export const ContainerCor = styled.div`
    .area-cores{ 
        display: flex;
        flex-wrap: flex-wrap;        
        gap: 0.5rem;       
        div{
            width: 100%;
            height: 20rem;
            border: 1px solid #333;
            background-color: ${props => props.color}
        }
    }

`
